import { Component, ComponentFactoryResolver, ComponentRef, OnInit, Output, ViewChild } from '@angular/core';
import { DynamicHostDirective } from 'src/app/core/directives/dynamic-host.directive';
import { AutocompleteAddressComponent } from '../autocomplete-address/autocomplete-address.component';
import { BasicAddress } from 'src/app/core/interfaces/basicAddress';
import { EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-multiple-addresses',
  templateUrl: './multiple-addresses.component.html',
  styleUrls: ['./multiple-addresses.component.scss']
})
export class MultipleAddressesComponent implements OnInit {
  @Output() emitToParent: EventEmitter<BasicAddress[]> = new EventEmitter();
  @ViewChild(DynamicHostDirective) public dynamicHost!: DynamicHostDirective;
  instanceCount: number = 0;
  addressStructure: BasicAddress = {
    address: '',
    location: {
      lat: 0,
      lng: 0
    }
  }
  addresses: Array<BasicAddress> = [];
  componentRefs = [];
  addressControls: FormArray = new FormArray([]);
  subscriptions: Subscription = new Subscription();
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    public fb: FormBuilder
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.createComponent();
    }, 10);
  }

  createComponent(increaseCount?: boolean): void {
    if (increaseCount) this.instanceCount++;
    this.addresses.push(this.addressStructure);
    const component = this.componentFactoryResolver.resolveComponentFactory(AutocompleteAddressComponent);
    const componentRef = this.dynamicHost.viewContainerRef.createComponent(component);
    const element = componentRef.location.nativeElement;
    element.classList.add('col-12', 'col-md-6', 'col-lg-3', 'pr-md-0');
    this.componentRefs.push(componentRef);
    const instance = componentRef.instance as AutocompleteAddressComponent;
    const formControl = new FormControl('', Validators.required);
    this.addressControls.push(formControl);
    instance.options = {
      title: `Dirección de cargue ${this.instanceCount + 1}`,
      appearance: 'outline',
      id: this.instanceCount,
      cleanAddress: true,
      showHintRequiredAddressSelection: true,
      selectAddressOnMap: true
    };
    instance.inputFormControl = formControl;
    const subscription = instance.inputFormControl.valueChanges.subscribe(
      (data: { address?: string, location?: { lat: number, lng: number }, delete?: boolean } | null) => {
        if (data) {
          if (data.delete) {
            this.deleteComponent(instance.options.id);
          } else {
            this.addresses[instance.options.id] = data;
            this.emitToParent.emit(this.addresses);
          }
        } else {
          this.addresses[instance.options.id] = this.addressStructure;
          this.emitToParent.emit(this.addresses);
        }
      }
    )
    this.subscriptions.add(subscription);
  }

  deleteComponent(index: number): void {
    if (index >= 0 && index < this.componentRefs.length) {
      this.componentRefs[index].destroy();
      this.componentRefs.splice(index, 1);
      this.addresses.splice(index, 1);
      this.componentRefs.forEach((componentRef, i) => {
        const instance = componentRef.instance as AutocompleteAddressComponent;
        instance.options.id = i;
        instance.options.title = `Dirección de cargue ${i + 1}`;
      })
      this.instanceCount = this.addresses.length - 1;
      this.emitToParent.emit(this.addresses);
    }
  }

  ngOnDestroy() {
    if (this.subscriptions) this.subscriptions.unsubscribe();
  }
}
